import React from "react";
import { useNavigate } from "react-router-dom";
import "./BreadCrumb.scss";

const BreadCrumb = ({ items }) => {
	const navigate = useNavigate();

	const handleClick = (url) => {
		navigate(url);
	};

	return (
		<div className="bread-crumb">
			{items.map((item, index) => (
				<React.Fragment key={`breadCrumb-${index}`}>
					<label
						onClick={() => handleClick(item.url)}
						className="link"
						id={item.navId}
					>
						{item.label}
					</label>
					{index < items.length - 1 && (
						<label className="separator">&nbsp;{">>"}&nbsp;</label>
					)}
				</React.Fragment>
			))}
		</div>
	);
};

export default BreadCrumb;
